// Components
import banners from './components/banners';
import accordion from './components/accordion';
import menu from './components/menu';
import teamSlider from './components/team-slider';
import videosSlider from './components/videos-slider';
import quotes from './components/quotes';
import whereNext from './components/where-next';
import events from './components/events';
import instagramFeed from './components/instagram-feed';
import expandingVideo from './components/expanding-video';
// import CustomCursor from './components/CustomCursor';

// Templates
import Home from './templates/Home';
import Contact from './templates/Contact';
import AdmissionsOverview from './templates/AdmissionsOverview';
import AdmissionsProcess from './templates/AdmissionsProcess';
import AgeChecker from './templates/AgeChecker';
import Houses from './templates/Houses';

// Packages
import 'magnific-popup';



function init() {
    // Components
    banners();
    accordion();
    menu();
    teamSlider();
    videosSlider();
    quotes();
	whereNext();
    events();
    instagramFeed();
	expandingVideo();
    // CustomCursor();

    // Templates
    Home();
    Contact();
    AdmissionsOverview();
    AdmissionsProcess();
    AgeChecker();
    Houses();

    document.querySelectorAll('.button:not([type="submit"])').forEach(button => button.dataset.text = button.textContent);
}

// has to be done before on scroll animations
// $('.prose blockquote cite').each(function () {
//     $(this).unwrap('p');
// });

init();




jQuery(document).ready(function ($) {
    consoleMessage: {
        console.log('%cCreated by %cTWK%cwww.thewebkitchen.co.uk', 'background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;', 'background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;', 'background: #FFFFFF; padding: 5px 10px;');
	}
	fixedheader: {
		$(function () {
			$(window).scroll(function () {
				if ($(window).scrollTop() >= 150) {
					$('.header').addClass('fixed-header');
				}
				if ($(window).scrollTop() >= 160) {
					$('.header').addClass("transform-none");
				}
				else {
					$('.header').removeClass('fixed-header');
					$('.header').removeClass("transform-none");
				}
			});
		});
	}

	search: {
		$('.search-icon').on('click', function (e) {
			$('.searchform').toggleClass('search-open');
			$(this).toggleClass('submit-zindex');
			$('.select-lang').removeClass('transform-height');
			$('#menu-main-menu-top, .lang_dropdown').fadeOut();
			$("#s").focus();
			setTimeout(function () {
				$('.close-search').fadeIn();
			}, 300);
		});
		$('.close-search').on('click', function (e) {
			$(this).fadeOut();
			$('.searchform').removeClass('search-open');
			$('.search-icon').removeClass('submit-zindex');
			$('#menu-main-menu-top, .lang_dropdown').fadeIn();
		});
	}

	menu: {
		// Open submenu on click
		$( '.top-nav .menu-item-has-children > a' ).on('click', function(e){
			e.preventDefault();

			$('.menu-item-has-children').removeClass('sub-menu-open'); // reset
			$('.sub-menu-wrap').removeClass('sub-menu-open');          // reset

			$(this).closest('.menu-item-has-children').toggleClass('sub-menu-open');
			$(this).next('.sub-menu-wrap').toggleClass('sub-menu-open');
		});
		// Open menu with tabs - accessibility
		$( '.top-nav .sub-menu-wrap a' ).on('focusin', function(){
			$(this).closest('.menu-item-has-children').addClass('sub-menu-open');
			$(this).closest('.sub-menu-wrap').addClass('sub-menu-open');

			console.log($(this));
		});
		$( '.top-nav .sub-menu-wrap a' ).on('focusout', function(){
			$(this).closest('.menu-item-has-children').removeClass('sub-menu-open');
			$(this).closest('.sub-menu-wrap').removeClass('sub-menu-open');
		});
		// Close on click outside.
		$(document).on('click', function(e){
			if ( ! $(e.target).parent().hasClass('menu-item') && $('.sub-menu-wrap').has(e.target).length === 0 ){
				$('.menu-item-has-children').removeClass('sub-menu-open');
				$('.sub-menu-wrap').removeClass('sub-menu-open');
			}
		});
		
	}

	anchorlinks: {
		$(document).on('click', '[data-scroll-to]', function (event) {
			event.preventDefault();

			$('html, body').animate({
				scrollTop: $($.attr(this, 'href')).offset().top - 100
			}, 500);
		});
	}

	externallinks: {
		$('a[href^="mailto:"]').each(function () {
			$(this).addClass('email-link');
		});	 
		
		$('a:not([target="_self"]):not(.email-link):not([class^="magnific-"]):not([data-target^="magnific"]').each(function () {
			var a = new RegExp('/' + window.location.host + '/');
			
			if (!a.test(this.href)) {
				$(this).click(function (event) {
				event.preventDefault();
				window.open(this.href, '_blank');
				});
			}
		});
		pdfs: {
			// Open PDFs in new window
			$(function () {
				$('a[href$=".pdf"]').prop('target', '_blank');
			});
		}
	}
	
	magnific: {
		// IFRAME
		$('[data-target="magnific-video"], .magnific-video').magnificPopup({
			type: 'iframe',
			mainClass: 'mfp-video-wrapper',
			removalDelay: 160,
			preloader: false,
			fixedContentPos: false,
			iframe: {
				markup: '<div class="mfp-iframe-scaler">' +
					'<div class="mfp-close"></div>' +
					'<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
					'</div>',
				patterns: {
					youtu: {
						index: 'youtu.be',
						id: function( url ) {
						
							// Capture everything after the hostname, excluding possible querystrings.
							var m = url.match( /^.+youtu.be\/([^?]+)/ );
					
							if ( null !== m ) {
								return m[1];
							}
					
							return null;
				
						},
						// Use the captured video ID in an embed URL. 
						// Add/remove querystrings as desired.
						src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0'
					},
					youtube: {
						index: 'youtube.com/',
						id: 'v=',
						src: 'https://www.youtube.com/embed/%id%?autoplay=1'
					}
				}
			},
            closeMarkup: `<button title="%title%" type="button" class="mfp-close !top-0 !right-0 !p-0 !-translate-y-1/2 !translate-x-1/2"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#1A3F94" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>`
		});

        $('[data-target="magnific-basic"]').magnificPopup({
            type: 'inline',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: true,
            fixedBgPos: true,
            overflowY: 'hidden',
            autoFocusLast: false,
            closeMarkup: `
            <button title="%title%" type="button" class="mfp-close">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="72px" height="72px" viewBox="0 0 72 72" version="1.1">
                    <title>close-icon</title>
                    <g id="Round-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="close-icon">
                            <circle id="Oval" stroke="#FFFFFF" fill="#FFFFFF" cx="36" cy="36" r="35.5"/>
                            <rect id="Rectangle" fill="#000000" transform="translate(36.5, 36) rotate(-315) translate(-36.5, -36)" x="24" y="35" width="25" height="2"/>
                            <rect id="Rectangle" fill="#000000" transform="translate(36.5, 36) rotate(-45) translate(-36.5, -36)" x="24" y="35" width="25" height="2"/>
                        </g>
                    </g>
                </svg>
            </button>
            `
        });

        $('[data-target="search-popup-trigger"]').magnificPopup({
            type: 'inline',
            mainClass: 'mfp-fade search-popup',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: true,
            fixedBgPos: true,
            overflowY: 'hidden',
            autoFocusLast: false,
            closeMarkup: `
            <button title="%title%" type="button" class="mfp-close !fixed">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="72px" height="72px" viewBox="0 0 72 72" version="1.1">
                    <title>close-icon</title>
                    <g id="Round-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="close-icon">
                            <circle id="Oval" stroke="#FFFFFF" fill="#FFFFFF" cx="36" cy="36" r="35.5"/>
                            <rect id="Rectangle" fill="#000000" transform="translate(36.5, 36) rotate(-315) translate(-36.5, -36)" x="24" y="35" width="25" height="2"/>
                            <rect id="Rectangle" fill="#000000" transform="translate(36.5, 36) rotate(-45) translate(-36.5, -36)" x="24" y="35" width="25" height="2"/>
                        </g>
                    </g>
                </svg>
            </button>
            `
        });
	}

	accordion: {
		if ($('.block--accordion').length) {

			$( '.accordion__content--wrapper' ).css('display', 'none'); // All items closed.
	
			$('.block--accordion').find('.js-accordion-trigger').on('click', function() {

				// Close only the items in this accordion.
				$(this).parent().siblings().find('.js-accordion-trigger').next().slideUp('fast'); // reset
				$(this).parent().siblings().find('.js-accordion-trigger').removeClass('open');    // reset

				// Close items in all accordions on the page.
				//$('.js-accordion-trigger').not(this).next().slideUp('fast'); // reset
				//$('.js-accordion-trigger').not(this).removeClass('open');    // reset
				
				if ($(this).hasClass('open')){
					$(this).next().slideUp('fast');
					$(this).removeClass('open');
				} else {
					$(this).next().slideDown('fast');
					$(this).addClass('open');
				}
				
			});
		}
	}

	/* tabs: {
		const tabs = document.querySelectorAll('[role="tab"]');
		const tabList = document.querySelector('[role="tablist"]');

		if ( tabs ) {

			// Add a click event handler to each tab
			tabs.forEach(tab => {
				tab.addEventListener("click", changeTabs);
			});

			// Enable arrow navigation between tabs in the tab list
			let tabFocus = 0;

			if ( tabList ) {
				tabList.addEventListener("keydown", e => {
					// Move right
					if (e.keyCode === 39 || e.keyCode === 37) {
					tabs[tabFocus].setAttribute("tabindex", -1);
					if (e.keyCode === 39) {
						tabFocus++;
						// If we're at the end, go to the start
						if (tabFocus >= tabs.length) {
						tabFocus = 0;
						}
						// Move left
					} else if (e.keyCode === 37) {
						tabFocus--;
						// If we're at the start, move to the end
						if (tabFocus < 0) {
						tabFocus = tabs.length - 1;
						}
					}
	
					tabs[tabFocus].setAttribute("tabindex", 0);
					tabs[tabFocus].focus();
					}
				});
			}

			function changeTabs(e) {
				console.info('tabs clicked');
				const target = e.target;
				const parent = target.parentNode;
				const grandparent = parent.closest('.tabs');


					console.info(grandparent);
				// Remove all current selected tabs
				parent
					.querySelectorAll('[aria-selected="true"]')
					.forEach(t => t.setAttribute("aria-selected", false));

				// Set this tab as selected
				target.setAttribute("aria-selected", true);

				// Hide all tab panels
				grandparent
					.querySelectorAll('[role="tabpanel"]')
					.forEach(p => p.setAttribute("hidden", true));

				// Show the selected panel
				grandparent.parentNode
					.querySelector(`#${target.getAttribute("aria-controls")}`)
					.removeAttribute("hidden");
			}

		}
	} */

	loadingAnimations: {
		$.fn.isOnScreen = function () {
			var win = $(window);
			var viewport = {
				top: win.scrollTop()
			};
			viewport.bottom = viewport.top + win.height() - 80;
		
			var bounds = this.offset();
			bounds.bottom = bounds.top + this.outerHeight();
		
			return (!(viewport.bottom < bounds.top || viewport.top > bounds.bottom));
		};

		// First load Animation
		$('.off-screen').each(function (index) {
			if ($(this).isOnScreen()) {
				$(this).removeClass('off-screen--hide');
			}
		});

		// Animation on scroll
		$(window).scroll(function () {
			$('.off-screen').each(function (index) {
				if ($(this).isOnScreen()) {
					$(this).removeClass('off-screen--hide');
				}
			});
		});
	}
    tables: {
        $('.tablepress').wrap('<div class="tablewrapper"></div>');
      }
});


